import React, { useState, useEffect } from 'react';
import styles from '../static/styles/DailyGamingTasks.module.css';
import weeklyTournamentStyles from '../static/styles/WeeklyTournaments.module.css';
import calendarIcon from '../static/img/Home/calendarIcon.svg';
import { fetchDailyGames, listEslGames } from '../api/games';
import gamesListRaw from '../static/data/games.json';

import ArrowLeft from '../static/img/backArrow.png'
import playIcon from '../static/img/DailyGamingTasks/play.png';
import pubgIcon from '../static/img/DailyGamingTasks/iconPubgDailyTasks.png';
import pubgImage from '../static/img/DailyGamingTasks/imagePubgDaily.avif';
import apexIcon from '../static/img/DailyGamingTasks/iconApexDailyTasks.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexDaily.avif';
import codIcon from '../static/img/DailyGamingTasks/iconCODDailyTasks.avif';
import codImage from '../static/img/DailyGamingTasks/iamgeCODDaily.avif';
import minecraftIcon from '../static/img/DailyGamingTasks/iconMinecraftDailyTasks.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftDaily.avif';
import clashOfClansIcon from '../static/img/DailyGamingTasks/iconCOCDailyTasks.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCDaily.avif';
import clashRoyaleIcon from '../static/img/DailyGamingTasks/iconCRDailyTasks.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRDaily.avif';
import fortniteIcon from '../static/img/DailyGamingTasks/iconFortniteDailyTasks.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteDaily.avif';
import amongUsIcon from '../static/img/DailyGamingTasks/iconAmongUsDailyTasks.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageSusDaily.avif';
import subwaySurfersIcon from '../static/img/DailyGamingTasks/iconSubSurfDailyTasks.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfDaily.avif';
import valorantIcon from '../static/img/DailyGamingTasks/iconValorantDailyTasks.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantDaily.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import freeFireImage from '../static/img/DailyGamingTasks/imageFreeFireDaily.avif';
import robloxIcon from '../static/img/DailyGamingTasks/iconRobloxDailyTasks.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxDaily.avif';
import fifaIcon from '../static/img/DailyGamingTasks/iconFifaDailyTasks.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import eightBallPoolImage from '../static/img/DailyGamingTasks/image8BallDaily.avif';
import eightBallPoolIcon from '../static/img/DailyGamingTasks/icon8BallPool.avif';
import aimTrainCover from '../static/img/MadeByESL/coverAimTrain.avif';
import cannonClashCover from '../static/img/MadeByESL/coverCannonClash.avif';
import puzzleManiaCover from '../static/img/MadeByESL/coverPuzzleMania.avif';
import spaceFootballCover from '../static/img/MadeByESL/coverSpaceFootball.png.avif';
import CannonClashInstructions from '../components/CannonClashInstructions';

import { useNavigate } from 'react-router-dom';
import { trackGameCardClick } from '../utils/analytics';


// TODO: Centralize these funcs
const getGameIcon = (gameName) => {
    switch (gameName.toLowerCase()) {
        case 'pubg mobile': return pubgIcon;
        case 'apex legends': return apexIcon;
        case 'call of duty': return codIcon;
        case 'minecraft': return minecraftIcon;
        case 'clash of clans': return clashOfClansIcon;
        case 'clash royale': return clashRoyaleIcon;
        case 'fortnite': return fortniteIcon;
        case 'among us': return amongUsIcon;
        case 'subway surfers': return subwaySurfersIcon;
        case 'valorant': return valorantIcon;
        case 'freefire': return freeFireIcon;
        case 'roblox': return robloxIcon;
        case 'fifa mobile': return fifaIcon;
        case '8 ball pool': return eightBallPoolIcon;
        case 'puzzle mania': return puzzleManiaCover;

        default: return null;
    }
};

const getGameImage = (gameName) => {
    switch (gameName.toLowerCase()) {
        case 'pubg mobile': return pubgImage;
        case 'apex legends': return apexImage;
        case 'call of duty': return codImage;
        case 'minecraft': return minecraftImage;
        case 'clash of clans': return clashOfClansImage;
        case 'clash royale': return clashRoyaleImage;
        case 'fortnite': return fortniteImage;
        case 'among us': return amongUsImage;
        case 'subway surfers': return subwaySurfersImage;
        case 'valorant': return valorantImage;
        case 'freefire': return freeFireImage;
        case 'roblox': return robloxImage;
        case 'fifa mobile': return fifaImage;
        case '8 ball pool': return eightBallPoolImage;
        case 'aim train': return aimTrainCover;
        case 'cannon clash': return cannonClashCover;
        case 'puzzle mania': return puzzleManiaCover;
        case 'space football': return spaceFootballCover;
        default: return null;
    }
};

const DailyGamingTasks = ({ isJcUser }) => {
    const [games, setGames] = useState([]);
    const [eslGames, setEslGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showInstructions, setShowInstructions] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Gaming Tasks | Jazz Esl"
        const loadGames = async () => {
            try {
                setLoading(true);
                setError(null);

                let gamesList = [];
                if (Array.isArray(gamesListRaw)) {
                    gamesList = gamesListRaw;
                } else if (typeof gamesListRaw === 'object' && gamesListRaw !== null) {
                    gamesList = gamesListRaw.default || [];
                }

                const [dailyGamesData, eslGamesResp] = await Promise.all([
                    fetchDailyGames(),
                    listEslGames()
                ]);
                setGames(dailyGamesData);

                let eslGamesArr = [];
                if (
                    eslGamesResp &&
                    eslGamesResp.success &&
                    eslGamesResp.data &&
                    Array.isArray(eslGamesResp.data.eslgames)
                ) {
                    eslGamesArr = eslGamesResp.data.eslgames
                        .map(eslGame => {
                            const match = gamesList.find(g =>
                                String(g.game_unique_id).toLowerCase() === String(eslGame.game_unique_id).toLowerCase()
                            );
                            if (match) {
                                return {
                                    ...match,
                                    ...eslGame
                                };
                            } else {
                                return {
                                    ...eslGame,
                                    game: eslGame.game_name
                                };
                            }
                        })
                        .filter(Boolean);
                } else {
                    // Fallback to static data if API fails
                    eslGamesArr = gamesList.map(game => ({
                        ...game,
                        game: game.game_name
                    }));
                }

                setEslGames(eslGamesArr);
            } catch (err) {
                setError(err.message || 'Failed to load daily games');
            } finally {
                setLoading(false);
            }
        };

        loadGames();
    }, []);

    if (loading) {
        return <div className={styles.loading}>Loading daily games...</div>;
    }

    if (error) {
        return <div className={styles.error}>{error}</div>;
    }

    const handleDailyGameClick = (gameId) => {
        if (!gameId) {
            return;
        }

        const gameObj = games.find(g => g.gameId === gameId || g.id === gameId || g.game_unique_id === gameId);
        const gameName = gameObj ? (gameObj.game || gameObj.game_name || '') : '';

        try {
            trackGameCardClick(gameName || gameId, gameId, 'daily_games_list');
        } catch (err) {
            // console.warn('analytics error', err);
        }

        if (gameId === 'cannon_clash_001') {
            navigate('/tournaments');
            return;
        }

        navigate(`/game-challenges?gameId=${encodeURIComponent(gameId)}`);
    };

    const handleInstructionsClose = () => {
        setShowInstructions(false);
    };

    const handleShowInstructions = (gameName) => {
        const isCannonClash = gameName && gameName.toLowerCase().includes('cannon');
        if (isCannonClash) {
            setShowInstructions(true);
        }
    };

    const gradients = [
        "linear-gradient(135deg, #1A0A3D, #080014)",
        "linear-gradient(135deg, #3D0A14, #1A0005)",
        "linear-gradient(135deg, #1A3D0A, #0A1A00)",
        "linear-gradient(135deg, #280A3D, #0C001A)",
    ];

    const gradients1 = [
        "linear-gradient(135deg, #FF7A00, #A84500)",
        "linear-gradient(135deg, #7A0000, #2A0000)",
        "linear-gradient(135deg, #0A1A3D, #000A1A)",
        "linear-gradient(135deg, #0A3A4A, #001A28)",
        "linear-gradient(135deg, #0A283D, #000A1A)",
        "linear-gradient(135deg, #0D3A14, #001408)",
    ];

    return (
        <div className={styles.container}>
            <div className={styles.navigationHeader}>
                <div
                    className={styles.navigationBack}
                    onClick={() => navigate(-1)}
                >
                    <img src={ArrowLeft} alt="<" />
                </div>
                <div className={styles.navigationTitle}>
                    <p>Earn credits</p>
                    <h2 className={styles.heading}>Daily Gaming Challenges</h2>
                </div>
            </div>
            <div className={styles.gamingTaskHeader}>
                <p className={styles.subheading}>Play - Compete - earn</p>
                <h2 className={styles.heading}>Gaming Challenges</h2>
                <div className={styles.headerstatsContainer}>
                    <div className={styles.headerstats}>
                        <span>{games.length}</span>
                        <p>Games</p>
                    </div>
                    <div className={styles.headerstats}>
                        <span>{eslGames.length}</span>
                        <p>orignals</p>
                    </div>
                    <div className={styles.headerstats}>
                        {isJcUser ? (
                            <span>1.2x</span>
                        ) : (
                            <span>1.0x</span>
                        )}
                        <p>Credits</p>
                    </div>
                </div>
            </div>

            <div className={styles.cardGrid1}>
                {games.map((game, index) => {
                    const gameIcon = getGameIcon(game.game);
                    const gameImage = getGameImage(game.game);

                    return (
                        <div
                            key={game.id}
                            className={styles['game-card']}
                            onClick={() => { handleDailyGameClick(game.gameId) }}
                        >
                            <div
                                key={game.id || index}
                                className={styles["game-image-container"]}
                                style={{
                                    "--bg": gradients1[index % gradients1.length],
                                }}
                            >
                                <img
                                    src={gameImage}
                                    alt={game.game}
                                    className={styles["game-image"]}
                                />

                                <div className={styles["game-name"]}>
                                    {game.game.length > 10
                                        ? `${game.game.substring(0, 10)}...`
                                        : game.game}
                                </div>

                                <button className={styles["game-button"]}>
                                    Select Game
                                </button>
                            </div>

                        </div>
                    );
                })}
            </div>
            
            <CannonClashInstructions
                isOpen={showInstructions}
                onClose={handleInstructionsClose}
            />
        </div>
    );
};

export default DailyGamingTasks;